import React, {
  FormEvent,
  FunctionComponent,
  useCallback,
  useState,
} from 'react';

import { CardList, SubmitButton } from 'components';
import { FormGroup } from 'components/chroma';

import {
  getPrimaryPolicyHolderPersonalContact,
  getSelectedPolicyHolders,
} from 'scenes/motor/selectors';
import { MotorFullPageProps } from 'scenes/motor/types';

import { PersonalContactCard } from './PersonalContactCard';

export const PersonalPolicyContactStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  onNext,
}) => {
  const policyHolders = getSelectedPolicyHolders(funnelState);
  const {
    personalContactFirstName,
    personalContactLastName,
  } = getPrimaryPolicyHolderPersonalContact(funnelState);

  const [selectedPolicyHolderIndex, setSelectedPolicyHolderIndex] = useState(
    policyHolders.findIndex(
      (policyHolder) =>
        policyHolder.firstName === personalContactFirstName &&
        policyHolder.lastName === personalContactLastName
    )
  );

  const isSelected = (index: number): boolean =>
    index === selectedPolicyHolderIndex;

  const isValid = (): boolean => selectedPolicyHolderIndex !== -1;

  const onSubmit = useCallback(
    (event: FormEvent) => {
      const selectedPolicyHolder = getSelectedPolicyHolders(funnelState)[
        selectedPolicyHolderIndex
      ];
      onNext({
        personalContactFirstName: selectedPolicyHolder.firstName,
        personalContactLastName: selectedPolicyHolder.lastName,
      });
      event.preventDefault();
    },
    [onNext, funnelState, selectedPolicyHolderIndex]
  );

  return (
    <form onSubmit={onSubmit}>
      <FormGroup
        label="Select one policy holder to be the main contact."
        helpText="Communications sent out regarding the policy will be addressed to the selected individual."
      >
        <CardList>
          {policyHolders.map((policyHolder, index) => (
            <PersonalContactCard
              key={`${policyHolder.firstName}-${policyHolder.lastName}`}
              policyHolder={policyHolder}
              selected={isSelected(index)}
              onClick={() => setSelectedPolicyHolderIndex(index)}
            />
          ))}
        </CardList>
      </FormGroup>
      <SubmitButton enabled={isValid()}>Next</SubmitButton>
    </form>
  );
};

export default PersonalPolicyContactStep;
